<div class="group">
  {{ label }}
  <div>
    @for (option of options; track option) {
      <app-select-option
        [value]="option.value"
        [label]="option.label"
        [disabled]="option.disabled"
        [control]="control"
        (valueUpdated)="valueUpdated.emit($event)"
      ></app-select-option>
    }
  </div>
</div>
